import {EditOptionsModel} from "../../models/tasks/EditOptionsModel";
import {ClientApp} from "../../entities/ClientApp";
import {NotificationService} from "../../services/NotificationService";
import { ClientAppSettings } from "../../libs/ClientAppSettings";
import { Company } from "../../entities/Company";
import { ClientIds } from "../../libs/ClientIds";
import { GrantTypes } from "../../libs/GrantTypes";
import { MqttClient } from "../../entities/MqttClient";
import { PrintClient } from "../../entities/PrintClient";

export class EditOptionsCtrl {
    public static $inject = ['$scope','EditOptionsModel','$uibModal','NotificationService'];
    clientAppGridOptions: any;
    mqttClientGridOptions: any;
    printClientGridOptions: any;
    companyGridOptions: any;
    constructor(public $scope:any, public model:EditOptionsModel,public modal:angular.ui.bootstrap.IModalService, public notifyService:NotificationService) {
        $scope.vm = this;
        this.clientAppGridOptions = {
            multiSelect: false,
            columnDefs: [{ field: 'clientID', name: 'Client ID', width: 250 }, { field: 'grantType', name: 'Grant Type', width: 200 }, { field: 'secret', name: 'Secret', width: 150 }],
            data: [],
            onRegisterApi: function (gridApi: any) {
                gridApi.selection.on.rowSelectionChanged($scope, function (row: any) {
                    var entity = row.entity;
                    if (row.isSelected) {
                        $scope.vm.model.selectedClientApp = entity;
                    }
                    else {
                        $scope.vm.model.selectedClientApp = null;
                    }
                });
            }
        };
        this.printClientGridOptions = {
            multiSelect: false,
            columnDefs: [{ field: 'name', name: 'Name', width: 150 }, { field: 'lastSeen', name: 'Last Seen', cellFilter: 'date:\'yyyy-MM-dd HH:mm:ss\'', width: 150 }, { field: 'machineName', name: 'Machine Name', width: 150 }, { field: 'username', name: 'Username', width: 150 }, { field: 'password', name: 'Password', width: 150 }],
            data: [],
            onRegisterApi: function (gridApi: any) {
                gridApi.selection.on.rowSelectionChanged($scope, function (row: any) {
                    var entity = row.entity;
                    if (row.isSelected) {
                        $scope.vm.model.selectedPrintClient = entity;
                    }
                    else {
                        $scope.vm.model.selectedPrintClient = null;
                    }
                });
            }
        };
        this.mqttClientGridOptions = {
            multiSelect: false,
            columnDefs: [{ field: 'username', name: 'Username', width: 250 }, { field: 'password', name: 'Password', width: 150 }],
            data: [],
            onRegisterApi: function (gridApi: any) {
                gridApi.selection.on.rowSelectionChanged($scope, function (row: any) {
                    var entity = row.entity;
                    if (row.isSelected) {
                        $scope.vm.model.selectedMqttClient = entity;
                    }
                    else {
                        $scope.vm.model.selectedMqttClient = null;
                    }
                });
            }
        };
        this.companyGridOptions = {
            multiSelect: false,
            columnDefs: [{ name: 'name', width: 250 }],
            data: [],
            onRegisterApi: function (gridApi: any) {
                gridApi.selection.on.rowSelectionChanged($scope, function (row: any) {
                    var entity = row.entity;
                    if (row.isSelected) {
                        $scope.vm.model.selectedCompany = entity;
                    }
                    else {
                        $scope.vm.model.selectedCompany = null;
                    }
                });
            }
        };
        this.loadData();
    }//ctrl
    loadData(){
        this.model.loadData()
            .then((ok)=>{
                this.clientAppGridOptions.data = this.model.clientApps;
                this.mqttClientGridOptions.data = this.model.mqttClients;
                this.printClientGridOptions.data = this.model.printClients;
                this.companyGridOptions.data = this.model.companies;
            })
            .catch((exc:any)=>{
                this.notifyService.notifyError("Got error:"+exc);
            });
    }
    addAlarmMonitoringServiceClient():void {
        var found: boolean = false;
        for (var i = 0; i < this.model.clientApps.length; i++) {
            if (this.model.clientApps[i].clientID === ClientIds.ALARMMONITORINGSERVICE) {
                this.notifyService.notify("Alarm Monitoring Service client already added.");
                return;
            }
        }
        this.addClientApp(ClientIds.ALARMMONITORINGSERVICE);
    }
    addAlarmNotifierClient():void {
        var found: boolean = false;
        for (var i = 0; i < this.model.clientApps.length; i++) {
            if (this.model.clientApps[i].clientID === ClientIds.ALARMNOTIFIER) {
                this.notifyService.notify("Alarm Notifier client already added.");
                return;
            }
        }
        this.addClientApp(ClientIds.ALARMNOTIFIER);
    }
    addRADSClient():void {
        var found: boolean = false;
        for (var i = 0; i < this.model.clientApps.length; i++) {
            if (this.model.clientApps[i].clientID === ClientIds.RADS) {
                this.notifyService.notify("RADS client already added.");
                return;
            }
        }
        this.addClientApp(ClientIds.RADS);
    }
    addCustomClient(): void {
        this.addClientApp('');
    }
    addMqttClient(): void {
        var mqttClient = new MqttClient();
        this.openMqttClientDialog(mqttClient).then((ok) => {
            if (ok) {
                this.model.addMqttClient(mqttClient)
                    .then((id: number) => {
                        mqttClient.id = id;
                        this.mqttClientGridOptions.data.push(mqttClient);
                    })
                    .catch((exc: any) => {
                        this.notifyService.notify("Got error:" + exc);
                    });
            }
        });
    }
    editMqttClient(): void {
        var entity = this.model.selectedMqttClient;
        if (entity == null)
            return;
        this.openMqttClientDialog(entity).then((ok) => {
            if (ok) {
                this.model.editMqttClient(entity)
                    .then(() => {
                    })
                    .catch((exc: any) => {
                        this.notifyService.notify("Got error:" + exc);
                    });
            }
        });
    }
    deleteMqttClient(): void {
        var entity = this.model.selectedMqttClient;
        if (entity == null)
            return;
        this.model.deleteMqttClient(entity)
            .then(() => {
                var index = this.mqttClientGridOptions.data.indexOf(entity);
                this.mqttClientGridOptions.data.splice(index, 1);
                this.model.selectedMqttClient = null;
            })
            .catch((exc: any) => {
                this.notifyService.notify("Got error:" + exc);
            });
    }

    addPrintClient(): void {
        var printClient = new PrintClient();
        this.openPrintClientDialog(printClient).then((ok) => {
            if (ok) {
                this.model.addPrintClient(printClient)
                    .then((id: number) => {
                        printClient.id = id;
                        this.printClientGridOptions.data.push(printClient);
                    })
                    .catch((exc: any) => {
                        this.notifyService.notify("Got error:" + exc);
                    });
            }
        });
    }
    editPrintClient(): void {
        var entity = this.model.selectedPrintClient;
        if (entity == null)
            return;
        this.openPrintClientDialog(entity).then((ok) => {
            if (ok) {
                this.model.editPrintClient(entity)
                    .then(() => {
                    })
                    .catch((exc: any) => {
                        this.notifyService.notify("Got error:" + exc);
                    });
            }
        });
    }
    deletePrintClient(): void {
        var entity = this.model.selectedPrintClient;
        if (entity == null)
            return;
        this.model.deletePrintClient(entity)
            .then(() => {
                var index = this.printClientGridOptions.data.indexOf(entity);
                this.printClientGridOptions.data.splice(index, 1);
                this.model.selectedPrintClient = null;
            })
            .catch((exc: any) => {
                this.notifyService.notify("Got error:" + exc);
            });
    }



    addClientApp(clientId:string):void{
        var clientApp = new ClientApp();
        clientApp.grantType = GrantTypes.CLIENTCREDENTIALS;
        clientApp.clientID = clientId;
        this.openClientappDialog(clientApp).then((ok)=>{
            if(ok){
                this.model.addClientApp(clientApp)
                    .then((id:number)=>{
                        clientApp.id = id;
                        this.clientAppGridOptions.data.push(clientApp);
                    })
                    .catch((exc:any)=>{
                        this.notifyService.notify("Got error:"+exc);
                    });
            }
        });
    }
    editClientApp():void{
        var clientApp = this.model.selectedClientApp;
        if(clientApp == null)
            return;
        this.openClientappDialog(clientApp).then((ok)=>{
            if(ok){
                this.model.editClientApp(clientApp)
                    .then(() => {                        
                    })
                    .catch((exc: any) => {
                        this.notifyService.notify("Got error:" + exc);
                    }); 
            }
        });
    }
    deleteClientApp():void{
        var clientApp = this.model.selectedClientApp;
        if(clientApp == null)
            return;
        this.model.deleteClientApp(clientApp)
            .then(() => {
                var index = this.clientAppGridOptions.data.indexOf(clientApp);
                this.clientAppGridOptions.data.splice(index, 1);
                this.model.selectedClientApp = null;
            })
            .catch((exc: any) => {
                this.notifyService.notify("Got error:" + exc);
            });        
    }

    addCompany(): void {
        var company = new Company();
        this.openCompanyDialog(company).then((ok) => {
            if (ok) {
                this.model.addCompany(company)
                    .then((id: number) => {
                        company.id = id;
                        this.companyGridOptions.data.push(company);
                    })
                    .catch((exc: any) => {
                        this.notifyService.notify("Got error:" + exc);
                    });
            }
        });
    }
    editCompany(): void {
        var company = this.model.selectedCompany;
        if (company == null)
            return;
        this.openCompanyDialog(company).then((ok) => {
            if (ok) {
                this.model.editCompany(company);
            }
        });
    }
    deleteCompany(): void {
        var company = this.model.selectedCompany;
        if (company == null)
            return;
        if (this.model.companies.length < 2) {
            this.notifyService.notify("Cannot delete the last company.");
            return;
        }
        if (confirm("WARNING: Are you sure you want to delete this company? ALL data under this company will be permanently deleted.")) {
            this.model.deleteCompany(company);
            var index = this.companyGridOptions.data.indexOf(company);
            this.companyGridOptions.data.splice(index, 1);
            this.model.selectedCompany = null;
        }
    }

    openClientappDialog(clientApp: ClientApp): ng.IPromise<boolean> {
        console.log("omd");
        var modalInstance: angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.editclientapp.html').default,
            controller: 'EditClientAppCtrl',
            size: 'lg',
            resolve: {
                clientApp: function () {
                    return clientApp;
                }
            }
        });
        return modalInstance.result;
    }

    openMqttClientDialog(mqttClient: MqttClient): ng.IPromise<boolean> {
        var companyId: number = this.model.companies[0].id;
        var modalInstance: angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.editmqttclient.html').default,
            controller: 'EditMqttClientCtrl',
            size: 'lg',
            resolve: {
                mqttClient: function () {
                    return mqttClient;
                },
                companyId: function () {
                    return companyId;
                }
            }
        });
        return modalInstance.result;
    }

    openPrintClientDialog(printClient: PrintClient): ng.IPromise<boolean> {
        var companyId: number = this.model.companies[0].id;
        var modalInstance: angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.editprintclient.html').default,
            controller: 'EditPrintClientCtrl',
            size: 'lg',
            resolve: {
                printClient: function () {
                    return printClient;
                },
                companyId: function () {
                    return companyId;
                }
            }
        });
        return modalInstance.result;
    }

    openCompanyDialog(company: Company): ng.IPromise<boolean> {        
        var modalInstance: angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.editcompany.html').default,
            controller: 'EditCompanyCtrl',
            size: 'lg',
            resolve: {
                company: function () {
                    return company;
                }
            }
        });

        return modalInstance.result;
    }
}
